import { Breadcrumbs } from "PFComponents/breadcrumbs";
import { BreadcrumbItem } from "PFComponents/breadcrumbs/breadcrumb_item";
import { useTranslation } from "react-i18next";

type ScenarioBreadcrumbsProps = {
  activityId: string;
  activityName: string;
  scenarioName?: string;
};

export const ScenarioBreadcrumbs = ({ activityId, activityName, scenarioName }: ScenarioBreadcrumbsProps) => {
  const { t } = useTranslation(["translation", "activities"]);

  return (
    <Breadcrumbs>
      <BreadcrumbItem label={t("translation:workflow")} href="/workflow/engagements" />
      <BreadcrumbItem
        label={`${t("translation:engagement")}: ${activityName}`}
        href={`/activities/${activityId}/economics`}
      />
      {scenarioName ? (
        <BreadcrumbItem label={t("activities:scenario.scenarioBreadcrumb", { scenarioName })} isCurrent />
      ) : null}
    </Breadcrumbs>
  );
};
